import { render, staticRenderFns } from "./listCategories.vue?vue&type=template&id=fc2dae70&"
import script from "./listCategories.vue?vue&type=script&lang=js&"
export * from "./listCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports